<template>
	<section id="businessNote">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <div class="businessNoteWrapper">
        <div class="note column is-two-thirds has-text-centered b2bNotes">
          <p><b>Please Note:</b><br>
          As a Business to Business customer you will need to send us verification that you are a trade customer to activate your account. You'll get details on how to do this, and a list of accepted documents in your confirmation email. </p>
        </div>
      </div>
      <div class="actions">
        <button @click="back()" class="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toBusinessContactInfo()" class="button is-danger">Continue</button>
      </div>
    </div>
	</section>
</template>

<script>
import CancelButton from "../../components/actions/CancelButton";
export default {
  name: "businessNote",
  components: {
    CancelButton
  },
  methods: {
    toBusinessContactInfo() {
          this.$router.push("/businessContactInfo");

    },

    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
}
};
</script>